export default __webpack_public_path__ + "static/7516-71dcf5a6f0a0aa96d722e7816cec3142.jpg";